import React from 'react';
import '@progress/kendo-theme-default/dist/all.css';
import './index.css'; // oder './App.css'
import RoutesComponent from './routes';
import { FormProvider } from './contexts/FormContext'; // ✅ FormProvider importieren

const App: React.FC = () => {
  return (
    <FormProvider> {/* ✅ Context um die gesamte App setzen */}
      <div className="App">
        <RoutesComponent />
      </div>
    </FormProvider>
  );
}

export default App;
